import PropTypes from 'prop-types';
import React from 'react';
import { forOwn, uniq } from 'lodash';
import OverPanel from './OverPanel';
import { Button, TextInput } from 'pp-react';

import Select from './select';

import styles from './searchBox.less';

import * as analytics from '../lib/analytics';
import content from '../lib/i18n';
const i18n = content('hub/components/searchBox');

export default class extends React.Component {
  static contextTypes = {
    csrf: PropTypes.string,
  };

  static defaultProps = {
    categories: [],
    labels: {},
    states: {},
    query: {},
  };

  state = {
    enableOpen: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.renderUpdateDimentions();
  }

  componentDidUpdate() {
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.renderUpdateDimentions();
  };

  renderUpdateDimentions = () => {
    if (window.innerWidth <= 712) {
      this.setState({ enableOpen: true });
    } else {
      this.setState({ enableOpen: false });
    }
  };

  trackData = () => {
    let SearchInputRef = this.refs.searchInput.value;
    let CategoryInputRef = this.refs.categoryInput.state.value;
    let StateInputRef = this.refs.stateInput.state.value;

    analytics.trackLinkWithData(
      'SearchButton',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      {
        srkw: SearchInputRef,
        category: CategoryInputRef,
        state: StateInputRef,
      },
      'link'
    );
  };

  handleFocus = () => {
    document.getElementById('inputBoxSearchBar').blur();
  };

  renderModalBody = () => {
    const defaultCategory = this.props.query.category;

    const localizedCategories = this.props.categories
      ? uniq(
          this.props.categories.map(causeArea =>
            i18n(`label.category-${causeArea.id}`)
          )
        )
      : [];

    const categoryValueOptions = localizedCategories.map(item => {
      return {
        value: item,
        option: item,
      };
    });

    const stateValueOptions = [];
    forOwn(this.props.states, (value, key) => {
      stateValueOptions.push({
        value: key,
        option: value,
      });
    });
    const defaultState = this.props.query.state;

    return (
      <form
        action={this.props.searchSubmitUrl}
        method={'get'}
        className={'formStyle'}
      >
        <div className={'modalbodyContent'}>
          <div>
            <div className={'searchBox searchBoxMobileModal'}>
              <TextInput
                type={'text'}
                name='keywords'
                className={styles['ppvx_text-input']}
                autoComplete='off'
                value={this.state.query}
                label={i18n('label.search-placeholder-modal')}
              />
            </div>
            <div className={'selectCategory selectMobileModal'}>
              <Select
                name={'category'}
                placeholder={i18n('label.category')}
                valueOptions={categoryValueOptions}
                defaultValue={defaultCategory}
              />
            </div>
            <div className={'selectState selectMobileModal'}>
              <Select
                name={'state'}
                placeholder={i18n('label.state')}
                valueOptions={stateValueOptions}
                defaultValue={defaultState}
              />
            </div>
          </div>
          <div className={'searchButtonModal'}>
            <span className={''}>
              <Button ref={'cardButton'} type={'submit'}>
                {i18n('label.searchButton')}
              </Button>
            </span>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const defaultCategory = this.props.query.category;
    const localizedCategories = this.props.categories
      ? uniq(
          this.props.categories.map(causeArea =>
            i18n(`label.category-${causeArea.id}`)
          )
        )
      : [];

    const categoryValueOptions = localizedCategories.map(item => {
      return {
        value: item,
        option: item,
      };
    });

    const stateValueOptions = [];
    forOwn(this.props.states, (value, key) => {
      stateValueOptions.push({
        value: key,
        option: value,
      });
    });
    const defaultState = this.props.query.state;

    return (
      <div className={'searchContainer containerCust'}>
        <form
          action={this.props.searchSubmitUrl}
          method={'get'}
          className={'formStyle input-group'}
        >
          <div className={'row innerSearchContainer'}>
            <div className={'searchBoxContainer'}>
              <div className={'searchBox'}>
                {!this.state.enableOpen && !this.props.isMobile && (
                  <TextInput
                    name='keywords'
                    autoComplete='off'
                    maxLength={'256'}
                    value={this.state.query}
                    id={'inputBoxSearchBar'}
                    ref={'searchInput'}
                    label={i18n('label.search-placeholder')}
                  />
                )}
                {(this.state.enableOpen || this.props.isMobile) && (
                  <TextInput
                    data-ppvx_modal-id='searchbox'
                    name='keywords'
                    autoComplete='off'
                    maxLength={'256'}
                    value={this.state.query}
                    id={'inputBoxSearchBar'}
                    onFocus={this.handleFocus}
                    label={i18n('label.search-placeholder-modal')}
                  />
                )}
              </div>
              <div className={'searchIcon'} data-ppvx_modal-id='searchbox'>
                <span className={'icon search-icon'} />
              </div>

              <div className={'selectCategory changedisplay'}>
                <Select
                  name={'category'}
                  placeholder={i18n('label.category')}
                  ref={'categoryInput'}
                  valueOptions={categoryValueOptions}
                  defaultValue={defaultCategory}
                />
              </div>
              <div className={'selectState changedisplay'}>
                <Select
                  name={'state'}
                  placeholder={i18n('label.state')}
                  ref={'stateInput'}
                  valueOptions={stateValueOptions}
                  defaultValue={defaultState}
                />
              </div>
            </div>
            <div className={'searchbuttonContainer'}>
              <span>
                <Button
                  ref={'cardButton'}
                  id={'nemo_searchButton'}
                  onClick={this.trackData}
                  size='md'
                >
                  {i18n('label.searchButton')}
                </Button>
              </span>
            </div>
          </div>
        </form>
        <OverPanel
          modalId={'searchbox'}
          titleId={i18n('label.search-placeholder-modal')}
          renderModalBody={this.renderModalBody()}
        />
      </div>
    );
  }
}
